import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, IconButton } from '@mui/material';
import { USER_GUIDE_DUBBING_URL } from '@src/configs';
import { Close, ImportContactsRounded } from '@mui/icons-material';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import { ONBOARDING_POPUP_TYPE } from '@src/constants';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { StyledUserGuide } from './index.style';

const UserGuide = ({ onCloseUserGuide }) => {
  const { t } = useTranslation();
  const { getFeatureValue } = useFeatureFlags();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const onboardingPopupEnabled = getFeatureValue(
    FEATURE_KEYS.ONBOARDING_POPUP,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const onClickUserGuide = () => {
    if (onboardingPopupEnabled) {
      dispatch(
        actions.onboardingPopup.showOnboardingPopup({
          type: ONBOARDING_POPUP_TYPE.DUBBING,
        }),
      );
    } else {
      window.open(USER_GUIDE_DUBBING_URL, '_blank');
    }
  };

  return (
    <StyledUserGuide>
      <Typography variant="subtitle1">{t('sloganUserGuideDubbing')}</Typography>
      <div className="display-flex">
        <CommonButton
          startIcon={
            <ImportContactsRounded
              sx={{ fontSize: '24px', color: COLOR.navyBlue }}
            />
          }
          variant="outlined"
          className="dialog-actions-button"
          sx={{
            border: `1px solid ${COLOR.secondary[16]}`,
            padding: '10px 16px',
            borderRadius: '8px',
          }}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.indigo.default,
          }}
          onClick={onClickUserGuide}
        >
          {t('onboardingViewGuideDetail')}
        </CommonButton>
        <IconButton color="secondary" onClick={onCloseUserGuide}>
          <Close />
        </IconButton>
      </div>
    </StyledUserGuide>
  );
};

export default UserGuide;
